<template>
    <div  v-click-outside="collapse"  :class="{extended: getWidth < 584 ? true :extended}">
        <div v-if="getWidth > 584" style="border: none; text-align: right; display:block;  padding-left: 6px;" class="menu-option" >
            <span @click="extend(!extended)" style="font-size: 34px; margin-top: 5px;  display: inline-block;" :class="{'arrow-flip': getWidth < 584 ? true :extended}" class="menu-link icon icon-chevron-with-circle-right"></span>
        </div>
        <div v-else style="height: 15px;">

        </div>
        <div v-on:click="emitTypeChange(option.type), extend(false) "  v-for="(option) in allMenuOptions" :key="option.item.id" class="menu-option" :class="{'option-active': $route.name == option.type.toLowerCase()}">
            <div class="label-link" :class="{'power': option.type == 'psu'}">
                <router-link  ref="rtrLink"
                    @click.native="setLayout('simple')"
                    :to='option.url'
                    class="menu-link"
                    :class="{'is-active': option.name.toLowerCase() == $route.name}"
                    >
                    <span>
                        <div :class="{ selected: option.item.contents!==null, incompatible: checkPartCompat({compatTable: getStateCompatTable, type: option.name}) == false}" class="b-icon" style="display: inline-block;vertical-align: sub;" v-html="iconClasses[option.item.id - 1]"></div>
                        <span
                        v-if="getWidth < 584"
                            style="margin-left: 15px; text-transform: capitalize"
                        >{{option.item.type == 'cpu' ? 'Processor' : option.item.type == 'gpu' ? 'Graphics' : option.item.type == 'psu' ? 'Power Supply' : option.item.type}}</span>
                    </span>
                </router-link> 
            </div>
            <div class="build-item-link" v-if="extended == true || getWidth < 584">
                <button v-on:click.stop style="outline: none;" v-if="option.item.contents!==null" @click="unset(option.item)" class="item-label btn-reset"><span class="icon icon-circle-with-cross"></span></button>
                <router-link @click.native="setLayout('simple')" style="margin-top: 3px;" v-if="option.item.contents==null && getWidth > 584" :to="option.url" class="item-label not-selected">Select</router-link>
                <div v-if="option.item.contents!==null && (option.type == 'ram' || option.type == 'gpu' || option.type == 'storage' ||option.type == 'graphics')"  
                    style="display: inline-block; border-color: #1997c6;" class="item-label selected fadeOut"
                    :class="{'current': option.type == $route.name}" >
                    <router-link :class="{incompatible: checkPartCompat({compatTable: getStateCompatTable, type: option.name}) == false}" @click.native="setLayout('advanced')" style=" text-decoration: none;" :to="option.url+'?id='+option.item.contents[0].id + '&redir=true'" class="">
                        <span v-if="option.type == 'ram' && option.item.contents.length <2 && option.item.contents.length !==0">{{option.item.contents[0].compat.ram_type + ' ' + parseInt(option.item.contents[0].compat.capacity)}}GB {{option.item.contents[0].brand}}</span>
                        <span v-else-if="option.item.contents.length <2 && option.item.contents.length !==0">{{option.item.contents[0].model}}</span>
                        <span v-if="option.item.contents.length >1 && option.type == 'ram'">
                            {{option.item.contents[0].compat['ram_type']}} 
                            {{getItemValue({item: option.item.contents, field: 'capacity'})}}GB 
                            <span style="color: #00bc8c; margin:0px;">({{option.item.contents.length}})</span>
                        </span>
                        <span v-if="option.item.contents.length >1 && option.type == 'storage'">
                            {{getItemValue({item: option.item.contents, field: 'capacity'})}}TB
                            <span style="color: #00bc8c; margin:0px;">({{option.item.contents.length}})</span>
                        </span>
                        <span v-if="option.item.contents.length >1 && (option.type == 'graphics' || option.type == 'gpu')">
                            {{getItemValue({item: option.item.contents, field: 'model'}).toLowerCase().includes('geforce') ? getItemValue({item: option.item.contents, field: 'model'}).substr(8):getItemValue({item: option.item.contents, field: 'model'})}}
                            <span style="color: #00bc8c; margin:0px;">({{option.item.contents.length}})</span>
                        </span>
                    </router-link>
                </div>
                <div v-else-if="option.item.contents!==null"  :class="{'current': option.item.contents.type == $route.name}" style="display: inline-block; border-color: #1997c6" class="item-label selected fadeOut">
                    <router-link @click.native="setLayout('advanced')" :class="{incompatible: checkPartCompat({compatTable: getStateCompatTable, type: option.name}) == false}" :to="option.url+'?id='+option.item.contents.id + '&redir=true'" class="">{{option.item.contents.model}}</router-link>
                </div>
            </div>
        </div>
        <div :class="{'collapsed-price': (!extended && getWidth > 584) || getWidth < 584}">
            <TotalCost style="margin-top: 15px;" :expanded="getWidth > 584 ? extended : true" :centsShow="false" class="build-total" :class="{'smaller': getTotalCostLocal() >= 1000}" />
        </div>
        <!-- Estimated performance -->
        <div v-if="((extended) && getWidth > 584) || getWidth < 584" class="perf-score">
            <h5 style="margin-bottom: 10px;"></h5>
            <div style="padding-left: 1.8%">
                <div class="perf-chart">
                    <div style=" display: inline-block;margin-left: 1.8%; margin-right:1.8%; border-radius: 3px; transition: 0.2s; box-shadow: inset 0 0 2px #191b20;" 
                    v-for="(item, index) in bars" :key="index" 
                    :style="[
                        getPerfColor(
                            getPerformance(allMenuOptions), index) == '#1997c6' 
                            ? {backgroundColor: item.activeColor} 
                            : {border: '1px solid '+item.color,}, {opacity: '0.9', width: item.width, height: getHeight(item.height)}]">
                    </div>
                </div>
            </div>
        </div>
        <div  v-if="extended || getWidth < 584" class="menu-optoins-buttons desktop-hide">
            <div v-if="dropdown && this.loggedIn == 'true'" class="drop-down" style="text-align: center;">
                <div style="position: relative">
                    <div style="position: absolute; right: 0px; top: -5px; cursor: pointer" v-if="this.dropdown == true" @click="closeDropdown()">
                        x
                    </div>
                    <div v-if="saved == 'not yet' || false">
                        <label style="display: block; text-align: center ">Build's Name: </label><input v-model="buildName">
                    </div>
                    <div v-if="getBuildAdded !== null">
                        <span @click="extend(!extended)" style="display: block; font-weight: bold">{{buildName}}</span>{{getBuildAdded}}<router-link :to="{path: '/users/mybuild'}">My Builds</router-link>
                    </div>
                    <div v-if="saving == true && error == false">
                        Saving...
                    </div>
                    <div style="color: #e64759; " v-if="saved == true && saving == false && getError !== null">
                        <div style="padding-bottom: 10px;">
                            {{getError}}
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="dropdown && this.loggedIn == 'false'" class="drop-down" style="border: none;text-align: center;">
            <div>
                Sign in first
            </div>
        </div>
        <!-- Greyed out button -->
        <button v-if="buildName == '' && error == false" :class="{'drop-down-opened': dropdown, inactive: typeof(buildName) == 'string'}" style="width: 100%; margin-top: 30px" class="gc-button">Save</button>
        <!-- Active button -->
        <button v-if="(this.loggedIn == 'false' && !dropdown  && buildName !== '' && error == false && getError == null && getBuildAdded == null)
            || (this.loggedIn == 'true' && dropdown && buildName !== '' && error == false && getError == null && getBuildAdded == null)
            || (this.loggedIn == 'true' && !dropdown && buildName !== '' && error == false && getError == null && getBuildAdded == null)
        " :class="{'drop-down-opened': dropdown}" @click="dropdownClick(buildName, getBuildRaw)" style="width: 100%; margin-top: 9px" class="gc-button">Save</button>
        <button @click="$router.push({path: '/users/login'}).catch(()=>{}), extend(false)" v-if="this.loggedIn == 'false' && dropdown" style="width: 100%; margin-top: 30px" class="gc-button">Sign In</button>
        <!-- Error button -->
        <button  v-if="error == true || getError !== null || getBuildAdded !== null" :class="{'drop-down-opened': dropdown}" @click="dropdownClick('OK'), extend(false, 150)" style="width: 100%; margin-top: 30px" class="gc-button">OK</button>
        <button @click="buildReset(), extend(false, 250)" style="width: 100%; margin-top: 10px" class="gc-button">Reset</button>
        <router-link :to="'/users/mybuild'"><button style="width: 100%; margin-top: 10px" class="gc-button">My Builds</button></router-link>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions }       from 'vuex';
import { EventBus }         from '../../eventBus'
import TotalCost            from './TotalCost.vue';
import {functions}          from '../../functions';
import ClickOutside         from 'vue-click-outside'


export default {
    name: 'MenuCollapsible',
    components: {
        TotalCost
    },
    directives: {
        ClickOutside
    },
    props: ['extended'],
    data(){
        return {
            iconClasses:    [
                // CPU
                `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" class="bi bi-cpu-fill" viewBox="0 0 16 16">
                    <path d="M6.5 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3z"/>
                    <path d="M5.5.5a.5.5 0 0 0-1 0V2A2.5 2.5 0 0 0 2 4.5H.5a.5.5 0 0 0 0 1H2v1H.5a.5.5 0 0 0 0 1H2v1H.5a.5.5 0 0 0 0 1H2v1H.5a.5.5 0 0 0 0 1H2A2.5 2.5 0 0 0 4.5 14v1.5a.5.5 0 0 0 1 0V14h1v1.5a.5.5 0 0 0 1 0V14h1v1.5a.5.5 0 0 0 1 0V14h1v1.5a.5.5 0 0 0 1 0V14a2.5 2.5 0 0 0 2.5-2.5h1.5a.5.5 0 0 0 0-1H14v-1h1.5a.5.5 0 0 0 0-1H14v-1h1.5a.5.5 0 0 0 0-1H14v-1h1.5a.5.5 0 0 0 0-1H14A2.5 2.5 0 0 0 11.5 2V.5a.5.5 0 0 0-1 0V2h-1V.5a.5.5 0 0 0-1 0V2h-1V.5a.5.5 0 0 0-1 0V2h-1V.5zm1 4.5h3A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5v-3A1.5 1.5 0 0 1 6.5 5z"/>
                </svg>`,
                // Motherboard
                `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" class="bi bi-motherboard" viewBox="0 0 16 16">
                    <path d="M11.5 2a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5Zm2 0a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5Zm-10 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6Zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6ZM5 3a1 1 0 0 0-1 1h-.5a.5.5 0 0 0 0 1H4v1h-.5a.5.5 0 0 0 0 1H4a1 1 0 0 0 1 1v.5a.5.5 0 0 0 1 0V8h1v.5a.5.5 0 0 0 1 0V8a1 1 0 0 0 1-1h.5a.5.5 0 0 0 0-1H9V5h.5a.5.5 0 0 0 0-1H9a1 1 0 0 0-1-1v-.5a.5.5 0 0 0-1 0V3H6v-.5a.5.5 0 0 0-1 0V3Zm0 1h3v3H5V4Zm6.5 7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-2Z"/>
                    <path d="M1 2a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2H.5a.5.5 0 0 1-.5-.5v-1A.5.5 0 0 1 .5 9H1V8H.5a.5.5 0 0 1-.5-.5v-1A.5.5 0 0 1 .5 6H1V5H.5a.5.5 0 0 1-.5-.5v-2A.5.5 0 0 1 .5 2H1Zm1 11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v11Z"/>
                </svg>`,
                // RAM
                `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28"  class="bi bi-memory" viewBox="0 0 16 16">
                    <path d="M1 3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4.586a1 1 0 0 0 .707-.293l.353-.353a.5.5 0 0 1 .708 0l.353.353a1 1 0 0 0 .707.293H15a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H1Zm.5 1h3a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5Zm5 0h3a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5Zm4.5.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-4ZM2 10v2H1v-2h1Zm2 0v2H3v-2h1Zm2 0v2H5v-2h1Zm3 0v2H8v-2h1Zm2 0v2h-1v-2h1Zm2 0v2h-1v-2h1Zm2 0v2h-1v-2h1Z"/>
                </svg>`,
                // Storage
                `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" class="bi bi-hdd-fill" viewBox="0 0 16 16">
                    <path d="M0 10a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-1zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm2 0a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM.91 7.204A2.993 2.993 0 0 1 2 7h12c.384 0 .752.072 1.09.204l-1.867-3.422A1.5 1.5 0 0 0 11.906 3H4.094a1.5 1.5 0 0 0-1.317.782L.91 7.204z"/>
                </svg>`,
                // Graphics
                `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" class="bi bi-gpu-card" viewBox="0 0 16 16">
                    <path d="M4 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm7.5-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"/>
                    <path d="M0 1.5A.5.5 0 0 1 .5 1h1a.5.5 0 0 1 .5.5V4h13.5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5H2v2.5a.5.5 0 0 1-1 0V2H.5a.5.5 0 0 1-.5-.5Zm5.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM9 8a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0Z"/>
                    <path d="M3 12.5h3.5v1a.5.5 0 0 1-.5.5H3.5a.5.5 0 0 1-.5-.5v-1Zm4 1v-1h4v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5Z"/>
                </svg>`,
                // PSU
                `<span style="font-size: 28px; " class="icon icon-flash"></span>`,
                // CASE
                `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" class="bi bi-pc" viewBox="0 0 16 16">
                    <path d="M5 0a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H5Zm.5 14a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm2 0a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1ZM5 1.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5ZM5.5 3h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1Z"/>
                </svg>`
            ],
            bars:[
                {
                    height:         '4px',
                    width:          '9px',
                    color:          '#434857',
                    activeColor:    '#e4d836'
                },
                {
                    height:         '8px',
                    width:          '9px',
                    color:          '#434857',
                    activeColor:    '#e4d836'
                },
                {
                    height:         '12px',
                    width:          '9px',
                    color:          '#434857',
                    activeColor:    '#e4d836'
                },
                {
                    height:         '16px',
                    width:          '9px',
                    color:          '#434857',
                    activeColor:    '#AFC543'
                },
                {
                    height:         '20px',
                    width:          '9px',
                    color:          '#434857',
                    activeColor:    '#AFC543'
                },
                {
                    height:         '24px',
                    width:          '9px',
                    color:          '#434857',
                    activeColor:    '#AFC543'
                },
                {
                    height:         '28px',
                    width:          '9px',
                    color:          '#434857',
                    activeColor:    '#92C14F'
                },
                {
                    height:         '32px',
                    width:          '9px',
                    color:          '#434857',
                    activeColor:    '#92C14F'
                },
                {
                    height:         '36px',
                    width:          '9px',
                    color:          '#434857',
                    activeColor:    '#92C14F'
                },
                {
                    height:         '40px',
                    width:          '9px',
                    color:          '#434857',
                    activeColor:    '#00BC8C'
                },
                {
                    height:         '44px',
                    width:          '9px',
                    color:          '#434857',
                    activeColor:    '#00BC8C'
                },
                {
                    height:         '48px',
                    width:          '9px',
                    color:          '#434857',
                    activeColor:    '#00BC8C'
                },
                {
                    height:         '52px',
                    width:          '9px',
                    color:          '#434857',
                    activeColor:    '#00BC8C'
                },
                {
                    height:         '56px',
                    width:          '9px',
                    color:          '#434857',
                    activeColor:    '#00BC8C'
                },
                {
                    height:         '60px',
                    width:          '9px',
                    color:          '#434857',
                    activeColor:    '#00BC8C'
                },
            ],
            buildName:      'My Gaming Monster',
            message:        false,
            error:          false,
        }
    },
    watch: {
        routeName(){
    }
    },
    computed: {
        ...mapGetters([
            'allMenuOptions',
            'getBuildRaw',
            'getUser',
            'getError',
            'getBuildAdded',
            'getBuild',
            'getBuildTDP',
            'getStateCompatTable',
            'loggedIn',
            'getBuidStatus',
            'getWarnings',
        ])
    },
    getWidth: () => parseInt(window.innerWidth),
        
    methods: {
         ...mapActions([
            'updateBuildStatus',
            'rmFromMenu',
            'rmFromBuild',
            'getBuild',
            'getPrice',
            'fetchItems',
            'setCurrentPartType',
            'saveBuild',
            'buildReset',
            'compatTableReset',
            'setLayout'
        ]),
        getHeight(height){
            var h = parseInt(height)
            var p = h*(h*0.025)
            return p+'px'
        },
        getTotalCostLocal(){
            return this.TotalCost
        },
        getPerformance: (build) =>  functions.getBuildPerformance(build).Total,
        getPerfColor(score, barIndex){
            var totalBars = this.bars.length
            var maxPerf = 160
            var bar = maxPerf/totalBars
            var result = score/(bar)
            if(result >= barIndex){
                return '#1997c6'
            }
            if(result < barIndex){
                return 'transparent'
            }
        },
        unset(item) {
            this.rmFromBuild({item: item, id: undefined});
            this.rmFromMenu({item: item, id: undefined});
            item.contents = null;
            this.getPrice() 
        },
        extend(bool, delay){
            setTimeout(() => {
                EventBus.$emit('extended', bool)
            }, typeof(delay) =='number'? delay : 0);
        },
        async emitTypeChange(newType){
            if(this.$route.name !== newType){
                this.$router.push(newType).catch(()=>{})
            }
            if(newType == 'gpu'){
                newType = 'graphics'
            }
            EventBus.$emit('emitTypeChange', newType)
            this.setCurrentPartType(newType)
            await this.fetchItems()
        },
        getItemValue({item, field}){
            console.log('getting item value: ', field, ' from ', item)
            var type = ''
            var length = 0
            var capacity = 0
            if(item && typeof(item) == 'object' && item.length >0){
                type = item[0].type
                length = item.length
            }
            else {
                type = item.type
            }
            if(type == 'ram'){
                if(field == 'capacity'){
                    capacity = 0
                    if(length >0){
                        item.map((itm) => capacity += parseInt(itm.compat.capacity))
                    }
                    return capacity
                }
            }
            if(type == 'storage'){
                if(field == 'capacity'){
                    capacity = 0
                    if(length >0){
                        item.map((itm) => capacity += parseInt(itm.specs.Capacity))
                    }
                    return capacity
                }
            }
            if(type == 'graphics' || type == 'gpu'){
                if(field == 'model'){
                    var model = item.model || ''
                    if(length >0){
                        model = item[0].model
                    }
                    console.log('got model: ', model)
                    return model
                }
            }
        },
        collapse(){
            this.extend(false)
        },
        checkPartCompat({compatTable, type}){
            var table = compatTable
            if(table && type){
                if(table[type.toLowerCase()]){
                    var fields = Object.keys(table[type.toLowerCase()])
                    if(fields && fields.length >0){
                        for(var i = 0; i < fields.length; i++){
                            if(table[type.toLowerCase()][fields[i]]){
                                var values = Object.keys(table[type.toLowerCase()][fields[i]])
                                for(var j = 0; j < values.length; j++){
                                    if(table[type.toLowerCase()][fields[i]][values[j]]
                                    && table[type.toLowerCase()][fields[i]][values[j]].compatible == false
                                    ){
                                        return false
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
                closeDropdown(){
            this.dropdown = false
        },
        async dropdownClick(buildName, build){
            if (!this.dropdown){
                this.dropdown = !this.dropdown
                return
            }
            if (buildName == 'OK'){
                this.dropdown = false;
                this.saving = false;
                this.saved = 'not yet'
                this.message = false
                this.error = false
                this.$store.dispatch('setError', null)
                this.$store.dispatch('setBuildAdded', null)
                return
            }
            else {
                if(typeof(buildName) == 'string' && buildName !==''){
                    this.saving = true;
                    console.log('save attempt...')
                    var user = this.$store.getters.getUser;
                    if(typeof(user) == 'string'){
                        user = JSON.parse(user)
                    }
                   await this.saveBuild({
                        name:       buildName,
                        author_id:  user.id,
                        ...build
                    })
                    this.saving = false;
                    this.saved = true;
                    console.log(this.getBuildAdded)
                }
            }
        },
    },
    mounted(){
        
    },
    beforeDestroy() {
        this.dropdownClick('OK')
    }
}
</script>

<style scoped>
.menu-optoins-buttons {
    padding: 15px 15px;
}
.perf-score {
    padding-left: 15px;
    text-align: left;
}
.collapsed-price {
    display: flex;
    justify-content: center;
}
.collapsed-price .build-total{
    margin-top: 5px !important;
}
.col-menu-icon {
  display:block;
}
.b-icon {
    margin-bottom: -4px;
    fill: #9198aa;
}
.b-icon.selected {
    fill: #00bc8c;
    color: #00bc8c;
}
.option-active {
    border-color: #1997c6 !important;
}
.option-active span{
    border-color: #1997c6 !important;
    color: #1997c6;
}
.power {
    margin-top: -2px !important;
}
.menu-option{
    font-size: 14pt;
    border: 1px solid #434857;
    padding: 4px;
    margin-bottom: 10px;
    border-radius: 6px;
    position: relative;
    text-align: center;
    height: 42px;
    transition: 0.2s;
    cursor: pointer;
    list-style: none;
    margin-left: 10px;
    margin-right: 10px;
    text-align: left;
    padding-left: 8px;
    padding-right: 8px;
    position: relative;
}
.build-item-link {
    padding-top: 4px;
}
.incompatible {
    color: #E64759 !important;
    fill: #E64759 !important;
}
.menu-link {
    margin-top: 2px !important;
    color: #9198aa; 
    font-size: 17pt;
    font-weight: lighter;
}
.build-total.smaller {
    transform: scale(0.7) !important
}
.menu-link:hover {
    text-decoration: unset;
    color: unset;
}
.is-active .b-icon{
    fill:  #1997c6;
}
.is-active .b-icon.selected {
    fill: #00bc8c;
}
.build-total {
    transform: scale(0.9)
}
.extended .menu-option{
    text-align: left;
    padding-left: 10px;
    padding-right: 10px;
    display: flex;
    justify-content: space-between;
}
.icon {
        margin-bottom: 2px !important;
}
.arrow-flip {
    padding: 0px;
    transform: rotate(180deg);
    text-align: right;
    margin-top: -10px !important;
    margin-right: -10px !important;
}
.item-label{
    text-align: left;
    background: transparent;
    position: inherit;
    animation: fadein 1s;
    -moz-animation: fade 1s ; /* Firefox */
    -webkit-animation: fadein 0.4s; /* Safari and Chrome */
    -o-animation: fadein 1s; /* Opera */
    color:#cfd2da;
}
.item-label.selected a{
    overflow: hidden;
    vertical-align: inherit;
}
.btn-reset {
    position: absolute;
    right: 10px;
    bottom: unset;
    left: unset;
    max-width: 15px;
    display: inline-block;
    background: transparent;
    border: none;
    font-weight: unset;
    font-size: 10pt;
    padding-top: 7px;
    color: #434857;
    top: 6px;
}
.btn-reset:hover {
    cursor: pointer;
    color: #E6474B;
    transform: scale(1.1) !important;
    transition: 0.2s;
}
.item-label.selected .b-icon{
    fill: #00bc8c !important;
}
.item-label.selected {
    vertical-align:sub;
    margin-right: 16px;
    box-shadow: 0px 0px 4px #191b20;
    margin-top: -1px;
    font-size: 12pt;
    display: inline-block;
    animation: fadein 1s;
    -moz-animation: fade 1s ; /* Firefox */
    -webkit-animation: fadein 1s; /* Safari and Chrome */
    -o-animation: fadein 1s; /* Opera */
}
 .item-label.selected:hover a{
    text-decoration: none !important;
}
.item-label.not-selected{
    color: #9198aa;
    font-size: 12pt !important;
    margin-right: 4px;
}
</style>